import React, { useState, useEffect } from 'react';
import { db } from '../LoginComp/firebase';

import {
  collection,
  query,
  where,
  getDocs,
  orderBy,
  limit,
  startAfter,
  getCountFromServer
} from 'firebase/firestore';

import './journal.css';

function Retina() {

  const [retinaBooks, setRetinaBooks] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [lastVisible, setLastVisible] = useState(null);

  // Fetch Retina Resources
  const fetchRetinaBooks = async (page) => {

    try {

      const pageSize = 6;

      const resourcesRef = collection(db, 'mainresources');

      let q = query(
        resourcesRef,
        where('resourceType', '==', 'Retina'),
        orderBy('created_at', 'desc'),
        limit(pageSize)
      );

      // Pagination
      if (page > 1 && lastVisible) {
        q = query(
          resourcesRef,
          where('resourceType', '==', 'Retina'),
          orderBy('created_at', 'desc'),
          startAfter(lastVisible),
          limit(pageSize)
        );
      }

      const querySnapshot = await getDocs(q);

      const books = querySnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data()
      }));

      setRetinaBooks(books);

      setLastVisible(
        querySnapshot.docs[querySnapshot.docs.length - 1]
      );

      // Count total
      const countSnapshot = await getCountFromServer(
        query(
          resourcesRef,
          where('resourceType', '==', 'Retina')
        )
      );

      setTotalPages(
        Math.ceil(countSnapshot.data().count / pageSize)
      );

    } catch (error) {
      console.error('Error fetching Retina resources:', error);
    }
  };

  const paginate = (page) => {
    setCurrentPage(page);
    fetchRetinaBooks(page);
  };

  useEffect(() => {
    fetchRetinaBooks(currentPage);
  }, [currentPage]);

  return (
    <div className="journal-page-container">

      {/* HERO */}
      <section className="hero">

        <div className="hero-image">
          <img src="/imgbook.png" alt="Retina Resources" />
        </div>

        <div className="hero-content">

          <h1>Eye Care Digital Library</h1>

          <p>
            Explore advanced retinal resources covering
            retinal diseases, diagnostic imaging, and modern
            vitreoretinal treatment approaches.
          </p>

        </div>

      </section>

      {/* HEADER */}
      <div className="journal-heading-section">
        <h2>Retina</h2>
        <p>
          Access clinical and academic materials on retinal disorders,
          diabetic retinopathy, macular degeneration, retinal detachment,
          and imaging techniques.
        </p>
      </div>

      {/* GRID */}
      <div className="articles-container">

        {retinaBooks.length > 0 ? (

          retinaBooks.map((book) => (

            <div key={book.id} className="article-item">

              {book.coverImageURL && (
                <img
                  src={book.coverImageURL}
                  alt={book.title}
                  className="book-cover-image"
                />
              )}

              <h4>{book.title}</h4>

              <div className="book-meta-data">

                {book.author && (
                  <p><strong>Author:</strong> {book.author}</p>
                )}

                {book.publication_year && (
                  <p><strong>Year:</strong> {book.publication_year}</p>
                )}

                {book.isbn && (
                  <p><strong>ISBN:</strong> {book.isbn}</p>
                )}

              </div>

              {book.description && (
                <p className="book-description">
                  {book.description}
                </p>
              )}

              {book.pdfFileURL && (
                <a
                  href={book.pdfFileURL}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="read-article-btn"
                >
                  Read Book
                </a>
              )}

            </div>

          ))

        ) : (
          <div className="no-books-found">
            <h3>No Resources Available</h3>
            <p>No Retina resources have been uploaded yet.</p>
          </div>
        )}

      </div>

      {/* PAGINATION */}
      {totalPages > 1 && (
        <div className="pagination-container">

          <button
            className="pagination-button"
            onClick={() => paginate(currentPage - 1)}
            disabled={currentPage === 1}
          >
            Previous
          </button>

          {Array.from({ length: totalPages }, (_, i) => (
            <button
              key={i + 1}
              className={`pagination-button ${currentPage === i + 1 ? 'active' : ''}`}
              onClick={() => paginate(i + 1)}
            >
              {i + 1}
            </button>
          ))}

          <button
            className="pagination-button"
            onClick={() => paginate(currentPage + 1)}
            disabled={currentPage === totalPages}
          >
            Next
          </button>

        </div>
      )}

    </div>
  );
}

export default Retina;